export const Contact = () => {
  return (
    <div
      className="container mx-auto px-8 flex flex-col justify-center items-center pt-32"
      id="contactForm"
    >
      <h2 className="text-white text-3xl uppercase font-black mb-4">
        Contact Me
      </h2>
      <form
        method="post"
        className="flex flex-col mt-4 max-w-lg w-full"
        name="contact"
      >
        <input type="hidden" name="form-name" value="contact" />
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          className="bg-transparent border border-solid border-white my-2 p-4 placeholder-white"
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          className="bg-transparent border border-solid border-white my-2 p-4 placeholder-white"
        />
        <input
          type="textarea"
          name="message"
          placeholder="Your Message"
          className="bg-transparent border border-solid border-white my-2 p-4 placeholder-white"
        />
        <input
          type="submit"
          value="Submit"
          className="bg-transparent border border-solid uppercase border-white my-2 py-4 px-2 cursor-pointer hover:text-black hover:bg-white transition-all"
        />
      </form>
    </div>
  );
};
